import { PlayersStatsTableItem } from "../../../types/player";
import { FCRodinaTable as Table } from "../../Table";
import { TablePlayerName } from "../../Table/PlayerName";

interface PlayersStatsTableProps {
    data: PlayersStatsTableItem[];
}

export const PlayersStatsTable: React.FC<PlayersStatsTableProps> = ({ data }) => {
    const dataColumns = [
        { title: 'Игрок', dataIndex: 'name', key: 'name', left: true },
        { title: 'И', dataIndex: 'matches', key: 'matches', tooltip: "Игры" },
        { title: 'Г', dataIndex: 'goals', key: 'goals', tooltip: "Голы" },
        { title: 'А', dataIndex: 'assists', key: 'assists', tooltip: "Ассисты" },
        { title: 'ЖК', dataIndex: 'yellowCards', key: 'yellowCards', tooltip: "Желтые карточки" },
        { title: 'КК', dataIndex: 'redCards', key: 'redCards', tooltip: "Красные карточки" },
        { title: 'ВЗ', dataIndex: 'matchesSubstIn', key: 'matchesSubstIn', tooltip: "Выходил на замену" },
        { title: 'БЗ', dataIndex: 'matchesSubstOut', key: 'matchesSubstOut', tooltip: "Был заменён" }
    ];

    const dataItems = data.map((item) => {
        return dataColumns.map((column) => {
            const value = item[column.dataIndex];
            if (column.dataIndex === 'name') {
                return {
                    key: column.key,
                    value: (
                        <TablePlayerName photoUrl={item.photo} name={value} url={item.url} />
                    )
                }
            }
            return {
                key: column.key,
                value
            }
        });
    });

    return (
        <>
            <div className="px-2 pb-2 sm:px-0">
                <div className="px-3 py-2 bg-slate-200/50 rounded-xl text-sky-950 text-sm sm:text-base">
                    <b>И</b> - игры, <b>Г</b> - голы, <b>А</b> - ассисты, <b>ЖК</b> - желтые карточки, <b>КК</b> - красные карточки, <b>ВЗ</b> - вышел на замену, <b>БЗ</b> - был заменен
                </div>
            </div>
            <Table
                columns={dataColumns}
                data={dataItems}
                rowClass="text-sm sm:text-2xl"
            />
        </>
    );
}

